import React from 'react';
import { LabelField, ImageField } from '../../components/Admin';

class UserModal extends React.Component {
	constructor(props){
		super(props);
		this.colors = ['#52697D', '#C9BC97', '#4E9242', '#313A42', '#AA6F62', '#C97676', '#4980AC'];
		this.state = { names: '', color: '', position: '', email: '', description: '', image: null, imageURL: void 0, edit: false };
		if (props.user) {
			this.state = {
				names: props.user.names,
				position: props.user.position,
				email: props.user.email,
				color: props.user.color,
				description: props.user.description,
				imageURL: props.user.imageId,
				edit: true
			};
		}
	}

	onSave = _ => {
		var { names, position, email, description, color, image, imageURL } = this.state;
		var user = { names, position, email, description, color, image, imageURL };
		this.props.onSave(user);
	};

	render(){
		var { names, position, email, description, color, edit } = this.state;
		var { closeModal, onRemove } = this.props;
		return (
			<div className="wp-modal">
				<div className="modal-content user-modal">
					<div className="modal-header">
						<i onClick={closeModal} className="icon-close"></i>
					</div>
					<div className="modal-form">
						<div className="clearfix">
							<div className="left">
								<ImageField onChange={(_, file, imageURL) => this.setState({image: file, imageURL})} name="Imagen" />
							</div>
							<div className="left">
								<LabelField defaultValue={names} onChange={(_, value) => this.setState({names: value})} name="Nombres" rows={1} />
							</div>
						</div>
						<div className="clearfix">
							<div className="left">
								<LabelField defaultValue={position} onChange={(_, value) => this.setState({position: value})} name="Cargo" rows={1} />
							</div>
							<div className="left">
								<LabelField defaultValue={email} onChange={(_, value) => this.setState({email: value})} name="Correo" rows={1} />
							</div>
						</div>
						<div className="clearfix">
							<div className="label-field">
								<label>Color identificador</label>
								<div className="color-list">
									{this.colors.map(c => (
										<div className={`${color === c ? 'active' : ''}`} onClick={_ => this.setState({color: c})} key={c} style={{backgroundColor: c}}></div>
									))}
								</div>
							</div>
						</div>
						<div className="clearfix">
							<LabelField defaultValue={description} onChange={(_, value) => this.setState({description: value})} name="Información extra" rows={2} />
						</div>
					</div>
					<div className="modal-buttons">
						{edit && <button onClick={onRemove} className="delete"><i className="icon-remove"></i> Eliminar integrante</button>}
						<button onClick={this.onSave} className="save">Guardar</button>
					</div>
				</div>
			</div>
		);
	}
}

export default class Users extends React.Component {
	state = { modalVisible: false, editItem: null, editIndex: -1 };

	closeModal = _ => {
		this.setState({modalVisible: false, editItem: null, editIndex: -1});
	}

	openModal = _ => this.setState({modalVisible: true, editItem: null, editIndex: -1});

	editUser = (user, index) => {
		this.setState({modalVisible: true, editItem: {...user}, editIndex: index})
	};

	addUser = user => {
		var { editItem, editIndex } = this.state;
		var { onChangeKey } = this.props;
		onChangeKey(({website, files}) => {
			var newUser = {
				websiteId: website.websiteId,
				names: user.names,
				email: user.email,
				position: user.position,
				description: user.description,
				imageId: user.imageURL,
				color: user.color
			};
			console.log(newUser);
			if (editItem && editIndex > -1){
				newUser.userId = editItem.userId;
				website.user[editIndex] = newUser;
			} else {
				website.user.push(newUser);
			}
			if (user.image){
				files[`user.${(editItem && editIndex > -1) ? editIndex : website.user.length-1}`] = user.image;
			}
			return { website, files };
		});
		this.setState({modalVisible: false, editItem: null, editIndex: -1});
	}

	onRemove = _ => {
		var { editIndex, editItem } = this.state;
		var { onChangeKey } = this.props;
		if (editItem && editIndex > -1){
			onChangeKey(({website, files}) => {
				website.user.splice(editIndex, 1);
				delete files[`user.${editIndex}`];
				return { website, files };
			});
		}
		this.setState({modalVisible: false, editItem: null, editIndex: -1});
	}

	render(){
		var { modalVisible, editItem } = this.state;
		var { website, onChangeProp } = this.props;
		return (
			<div>
				<LabelField defaultValue={website.userTitle} onChange={onChangeProp} prop="userTitle" name="Título" info="40 caracteres" rows={1} />
				<div className="label-field item-list">
					<label>Integrantes</label>
					{website.user.map((u, k) => (
						<div onClick={_ => this.editUser(u, k)} className="item" key={`${k}${u.names}`}>
							{u.names}
							<i className="icon-edit"></i>
						</div>
					))}
				</div>
				<div onClick={this.openModal} className="add-item">
					Nuevo Integrante
				</div>
				{ modalVisible && <UserModal onRemove={this.onRemove} user={editItem} onSave={this.addUser} closeModal={this.closeModal} /> }
			</div>
		)
	}
}
